import React from 'react';

import Nav from '../components/Nav';
import Header from '../components/Header';
import Footer from '../components/Footer';

function GetAQuote() {
  return (
    <>
        <Nav />
        <Header />
        <section class="wrapper inner-banner-wrapper testimonial-wrapper">
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <h2>Get a Quote</h2>
              </div>
            </div>
          </div>
        </section>
        <section class="wrapper custom-wrapper">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <p class="text-300">We are eager to know about your business requirement and suggest a business solution that suits your need and budget completely. Request a quote today.</p>
                <div class="quote-form">
                  <form action="" method="post" enctype="multipart/form-data">
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="">First Name <span>*</span></label>
                          <input type="text" class="form-control" name="FirstName" id="FirstName" value="" placeholder="" />
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="">Last Name <span>*</span></label>
                          <input type="text" class="form-control" name="LastName" id="LastName" value="" placeholder="" />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="">Email <span>*</span></label>
                          <input type="email" class="form-control" name="EmailAddrss" id="EmailAddrss" value="" placeholder="" />
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="">Phone </label>
                          <input type="text" class="form-control" name="PhoneNumber" id="PhoneNumber" value="" placeholder="" />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="">Do you currently have a website? Please enter the URL</label>
                          <input type="text" class="form-control" name="WebsiteURL" id="WebsiteURL" value="" placeholder="" />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <h3 class="form-title">Project Details</h3>
                          <p>Please tell me about your project. Try to be as detailed as possible.</p>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="">Project Type</label>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-6">
                        <div className="radio">
                          <label>
                            <input type="radio" name="ProjectType" value="Small Business Website or Blog" defaultChecked />
                            Small Business Website or Blog
                          </label>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="radio">
                          <label>
                            <input type="radio" name="ProjectType" value="eCommerce Website" />
                            eCommerce Website
                          </label>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="radio">
                          <label>
                            <input type="radio" name="ProjectType" value="Adhoc Website updates" />
                            Adhoc Website updates
                          </label>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="radio">
                          <label>
                            <input type="radio" name="ProjectType" value="Advice and Consultation" />
                            Advice and Consultation
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="">What is your project budget? <span>*</span></label>
                          <p>Please be honest so that I can determine what I can or can't do for your project.</p>
                          <select class="form-control" name="ProjectCost" id="ProjectCost">
                            <option value="$100 - $500">$100 - $500</option>
                            <option value="$500 - $1,000">$500 - $1,000</option>
                            <option value="$1,000 - $3,000">$1,000 - $3,000</option>
                            <option value="$3,000 - $5,000">$3,000 - $5,000</option>
                            <option value="$5,000 - $8,000">$5,000 - $8,000</option>
                            <option value="$8,000 - $15,000">$8,000 - $15,000</option>
                            <option value="$15,000 - $25,000">$15,000 - $25,000</option>
                            <option value="$25,000+">$25,000+</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="">Please provide some information on what your business does</label>
                          <textarea class="form-control" name="BusinessDetails" id="BusinessDetails"></textarea>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <button type="submit" class="btn btn-primary btn-lg">Submit</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
    </>
  )
}

export default GetAQuote